import React, { useState } from 'react'
import Col from 'antd/lib/col'
import Row from 'antd/lib/row'
import { HourPicker } from 'components/Widgets'
import dayjs, { Dayjs } from 'dayjs'
import { format } from 'date-fns'
import TextFieldNumber from './../../../Widgets/TextFieldNumber'

const CutoffTimeFields = ({
  disabled = false,
  updateCutoff,
  time,
  dayDiff
}: {
  disabled?: boolean
  updateCutoff?: (key: string, value: any) => void
  dayDiff?: number | null
  time?: string | null
}) => {
  const [cutOffTime, setCutOffTime] = useState<Dayjs>(
    dayjs(time || '00:00', 'hh:mm')
  )

  const onChange = (time: string) => {
    const timeAsDate = time
      ? dayjs(time, 'HH:mm').toDate()
      : dayjs('00:00:00', 'HH:mm:ss').toDate()

    const formattedTime = format(timeAsDate, 'HH:mm:ss')
    setCutOffTime(dayjs(formattedTime, 'hh:mm:ss'))

    updateCutoff && updateCutoff('time', formattedTime)
  }

  return (
    <Row className='_mb-0' align='middle' justify='end' gutter={8}>
      <Col style={{ width: '80px' }}>
        <TextFieldNumber
          inputType='number'
          placeholder=''
          style={{ maxWidth: '160px' }}
          disabled={disabled}
          min={1}
          defaultValue={dayDiff || 1}
          required
          value={dayDiff || 1}
          onChange={(e: number) => updateCutoff && updateCutoff('day_diff', e)}
        />
      </Col>
      <Col style={{ width: '120px' }}>
        <Row justify='center' align='middle' className='_mb-0'>
          {dayDiff === 1 ? 'day' : 'days'} before at
        </Row>
      </Col>
      <Col style={{ width: '120px' }}>
        <HourPicker
          dataTestId='cutoff-row-timepicker'
          disabled={disabled}
          value={dayjs(cutOffTime, 'HH:mm').format('HH:mm')}
          onChange={(time: string) => onChange(time)}
        />
      </Col>
      <Col span={2} />
    </Row>
  )
}

export default CutoffTimeFields
